var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.curFrame,
            expression: "curFrame",
            modifiers: { number: true }
          }
        ],
        attrs: { type: "range", min: "0", max: "500" },
        domProps: { value: _vm.curFrame },
        on: {
          __r: function($event) {
            _vm.curFrame = _vm._n($event.target.value)
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v("Keyframe = " + _vm._s(_vm.curFrame)),
      _c("br"),
      _c("balloon", { attrs: { position: _vm.balloonPos } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }